export default new class filterSearch {
  constructor() {
    this.searchInputFilter = '_filter-search';
    this.idSelector = 'data-search-by';
    this.searchHidden = 'filter-search__hidden';

    this.changeSearch();
  }

  changeSearch() {
    $(document).on('input', `.${this.searchInputFilter}`, (obEvent) => {
      this.searchHandler(obEvent);
    });
  }

  searchHandler(el) {
    const { target } = el;
    const id = target.getAttribute(this.idSelector);
    const sSearchString = $(el.currentTarget).val();
    const filter = sSearchString.toUpperCase();

    let divList;
    let div;
    let label;
    let i;

    // eslint-disable-next-line prefer-const
    divList = document.querySelector(id);
    // eslint-disable-next-line prefer-const
    div = divList.querySelectorAll('div');

    // eslint-disable-next-line no-plusplus
    for (i = 0; i < div.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      label = div[i].querySelectorAll('label')[0];
      if (label.innerHTML.toUpperCase()
        .indexOf(filter) > -1) {
        div[i].style.display = '';
      } else {
        div[i].style.display = 'none';
      }
    }
  }
}();
